module.exports = __webpack_public_path__ + "img/content1Linux.52c7ee37.svg";